import { jsx as _jsx } from "react/jsx-runtime";
import { useCopyClipboard } from '@layerswap/ui-kit';
import DepositQuoteDetails from './DepositQuoteDetails';
import { DepositAddressInfoView } from './DepositAddressInfoView';
const DepositAddressInfo = ({ sourceNetwork, sourceToken, destinationNetwork, destinationToken, destinationAddress, refuel, depositAddress, isCreatingSwap, }) => {
    const [copied, copy] = useCopyClipboard();
    const handleCopy = () => {
        if (depositAddress)
            copy(depositAddress);
    };
    return (_jsx(DepositAddressInfoView, { sourceNetwork: sourceNetwork, depositAddress: depositAddress, isCreatingSwap: isCreatingSwap, copied: copied, onCopy: handleCopy, quoteDetails: _jsx(DepositQuoteDetails, { sourceNetwork: sourceNetwork, sourceToken: sourceToken, destinationNetwork: destinationNetwork, destinationToken: destinationToken, destinationAddress: destinationAddress, refuel: refuel, isCreatingSwap: isCreatingSwap }) }));
};
export default DepositAddressInfo;
